import { useRef, useEffect, useCallback, useState } from "react";
import { createHeader } from "@utils/utils";
import ClientsUI from "./ClientsUI";
import { clientService } from "@services/ClientService";
import { ITableRow, IDataPage } from "../../../types/global";
import { debounce } from "lodash";
import { useNavigate } from "react-router-dom";
import { createClientRow } from "@utils/utils";
const Clients = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState<ITableRow[]>([]);
  const [clients, setClients] = useState<IDataPage>({});
  const [pages, setPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [search, setSearch] = useState("");
  const debouncedSearch = useRef(debounce(value => setSearch(value), 800)).current;
  const rowsPerPage = 6;
  const getAllClients = useCallback(async (skipPage = 0, localSearch = "") => {
    try {
      setIsLoading(true);
      const res = await clientService.getAll(6, skipPage * rowsPerPage, localSearch);
      setPages(Math.ceil(res.data.totalCount / rowsPerPage));
      setClients(clie => ({
        ...clie,
        [skipPage + 1]: {
          search: localSearch,
          items: [...res.data.items.map(client => {
            return createClientRow(client.id, client.fullName, client.identification, client.phone, client.email, client.creationTime);
          })]
        }
      }));
    } catch (error) {
      setShowError(true);
    } finally {
      setIsLoading(false);
    }
  }, []);
  useEffect(() => {
    setCurrentPage(1);
  }, [search]);
  useEffect(() => {
    setRows([]);
    const data = clients[currentPage];
    if (data && data.search === search) {
      setRows(data.items);
    } else {
      getAllClients(currentPage - 1, search);
    }
  }, [clients, getAllClients, currentPage, search]);
  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);
  useEffect(() => {
    getAllClients();
  }, [getAllClients]);
  const headers = [createHeader("Id", "id"), createHeader("Nombre", "fullName"), createHeader("Documento", "identification"), createHeader("Teléfono", "phone"), createHeader("Correo electrónico", "email"), createHeader("Acciones", "actions")];
  return <ClientsUI isLoading={isLoading} showError={showError} closeError={() => setShowError(false)} errorMessage="Hubo problemas para consultar" headers={headers} rows={rows} onClick={() => navigate("/clientes/crear")} pages={pages} currentPage={currentPage} onChangePage={setCurrentPage} onSearch={(value: string) => debouncedSearch(value)} onSearchClick={() => getAllClients(currentPage - 1, search)} />;
};
export default Clients;